'use client';

/**
 * Forced Matrix Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { CommissionsSection } from './CommissionsSection';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.forcedMatrixPlan.hero"
                imageSrc="/images/mlm-plans/forced-Matrix_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.forcedMatrixPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
                descriptionKeys={['description']}
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.forcedMatrixPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.forcedMatrixPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.forcedMatrixPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6', 'advantage7']}
                gridCols="3"
            />
            <CommissionsSection plan={plan} />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.forcedMatrixPlan.whySoftware" />
        </div>
    );
}
